import { Box, Grid, Modal, Typography } from '@mui/material';
import React, { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '400px',
  width: '660px',
  bgcolor: 'background.paper',
  border: '1px solid #ddd',
  boxShadow: 24,
  p: 4,
};

const spec = [
  { key: 'past', isFreeChecked: true },
  { key: 'present', isFreeChecked: true },
  { key: 'prediction', isFreeChecked: false },
  { key: 'notification', isFreeChecked: false },
];

const usePaymentModal = (feature: string) => {
  const [show, setShow] = useState<boolean>(false);
  const openModalShow = () => {
    setShow(true);
  };
  const closeModal = () => {
    setShow(false);
  };

  return {
    togglePaymentModal: openModalShow,
    PaymentModal: <PaymentModal show={show} closeModal={closeModal} feature={feature} />,
  };
};

const PaymentModal: FC<{ show: boolean; closeModal: () => void; feature: string }> = ({
  show,
  closeModal,
  feature,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={show} onClose={closeModal}>
      <Box sx={style}>
        <Typography style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
          {t('pages.predictionMap.paymentModal.title')}
        </Typography>
        <Typography style={{ fontSize: '1rem', marginTop: '6px' }}>
          {t(`pages.predictionMap.paymentModal.${feature}`)}
          {t('pages.predictionMap.paymentModal.featureIsLimited')}
        </Typography>
        <Box>
          {t('pages.predictionMap.paymentModal.inquiry')}
          <Link to="/prediction/contact" style={{ color: '#4169e1' }}>
            {t('pages.predictionMap.paymentModal.here')}
          </Link>
          .
        </Box>
        <Box>
          <Grid container spacing={2} style={{ marginTop: '12px' }}>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              <Box sx={{ textAlign: 'center', width: '100%', bgcolor: '#999', padding: '6px' }}>
                <Typography style={{ fontSize: '1.1rem', color: 'white' }}>
                  {t('pages.predictionMap.paymentModal.freePlan')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={5}>
              <Box sx={{ textAlign: 'center', width: '100%', bgcolor: '#007B43', padding: '6px' }}>
                <Typography style={{ fontSize: '1.1rem', color: 'white' }}>
                  {t('pages.predictionMap.paymentModal.paidPlan')}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: '-4px' }}>
            <Grid item xs={2}></Grid>
            <Grid item xs={5}>
              <Box sx={{ textAlign: 'left', width: '100%', bgcolor: '#eee', padding: '6px' }}>
                <Typography style={{ fontSize: '0.8rem' }}>
                  {t('pages.predictionMap.paymentModal.descriptionFree')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={5}>
              <Box sx={{ textAlign: 'left', width: '100%', bgcolor: '#b7ffdb', padding: '6px' }}>
                <Typography style={{ fontSize: '0.8rem' }}>
                  {t('pages.predictionMap.paymentModal.descriptionPaid')}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* ここからチェックボックス */}
          {spec.map((s, idx) => {
            return (
              <Grid container spacing={2} style={{ marginTop: '-4px' }} key={idx}>
                <Grid item xs={2}>
                  <Box>
                    <GrayOutlinedBox title={t(`pages.predictionMap.paymentModal.${s.key}`)} />
                  </Box>
                </Grid>
                <Grid item xs={5}>
                  <CheckboxWithColor isChecked={s.isFreeChecked} color={'#111'} />
                </Grid>
                <Grid item xs={5}>
                  <CheckboxWithColor isChecked={true} color={'#007B43'} />
                </Grid>
              </Grid>
            );
          })}
        </Box>
      </Box>
    </Modal>
  );
};

export default usePaymentModal;

const GrayOutlinedBox = ({ title }: { title: string }) => {
  return (
    <Box
      style={{
        border: '1px #ddd solid',
        textAlign: 'center',
        height: '30px',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {title}
    </Box>
  );
};

const CheckboxWithColor = ({ isChecked, color }: { isChecked: boolean; color: string }) => {
  return (
    <Box
      style={{
        backgroundColor: '#f6f6f6',
        height: '30px',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {(isChecked && <CheckIcon style={{ color: color, fontSize: '32px' }} />) || '-'}
    </Box>
  );
};
